<cv-schema-render-room34-skeleton *ngIf="!itemDirectiveData.rendered"></cv-schema-render-room34-skeleton>

<div class="card room-layout" [class]="cssClass" *ngIf="itemDirectiveData.rendered">
	<div *ngIf="title" class="card-header"
		 [ngStyle]="{
		 	'background-color': (layoutUIConfig?.uiConfig?.section?.header?.backgroundColor),
		 	'color': (layoutUIConfig?.uiConfig?.section?.header?.textColor)
		 }" >
		{{title}} {{ layoutNode?.uiConfig | json }}
	</div>
	<div class="card-body" [class]="this.options.bodyCssClass">
		<div class="row">
			<div class="col-md-12">
				<ng-container *ngFor="let item of layoutNode.items">
					<cv-schema-render-component [class]="item.options?.cssClass" [layoutNode]="item" [data]="data"></cv-schema-render-component>
				</ng-container>
			</div>
		</div>
	</div>
</div>
